import { IAuthState } from '@/shared/store/auth/auth.interfaces'

export default (): IAuthState => ({
  user: null,
  unauthorized: false,
  otherUsers: []
})
